import { createRouter, createWebHistory } from 'vue-router';
import store from './store';

// Shared component for all tutor dashboard sidebar routes
// Using the same reference ensures Vue Router REUSES the instance (no remount)
const accountDashboard = () => import('./components/page_account/p_1.vue');

const routes = [
  { 
    path: '/', 
    component: () => import('./components/page_landing/p_1.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/signin', 
    component: () => import('./components/page_sign_in/p_1.vue'),
    meta: { requiresAuth: false }
  },
  { 
    path: '/student/signup',
    redirect: () => {
      // Redirect to landing page and scroll to get started section
      setTimeout(() => {
        const element = document.getElementById('find-tutor');
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
      }, 100);
      return '/';
    },
    meta: { requiresAuth: false }
  },
  { 
    path: '/tutor/signup',
    redirect: () => {
      // Redirect to landing page and scroll to get started section
      setTimeout(() => {
        const element = document.getElementById('find-tutor');
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
      }, 100);
      return '/';
    },
    meta: { requiresAuth: false }
  },
  { 
    path: '/forgotpassword', 
    component: () => import('./components/page_forgot_password/p_1.vue'),
    meta: { requiresAuth: false }
  },
  { 
    path: '/account', 
    component: accountDashboard,
    meta: { requiresAuth: false }
  },
  { 
    path: '/account/edit', 
    component: () => import('./components/page_account_edit/p_1.vue'),
    meta: { requiresAuth: false }
  },
  { 
    path: '/account/find/tutors', 
    component: accountDashboard,
    meta: { requiresAuth: false }
  },
  { 
    path: '/book/tutor/:userId', 
    component: () => import('./components/page_account_book_tutor/p_1.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/account/bookings', 
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
  { 
    path: '/chat/message/:userId', 
    component: () => import('./components/page_acccount_chat_message/p_1.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/account/chat', 
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
  { 
    path: '/video/call', 
    component: () => import('./components/page_video_call/p_1.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/account/pay', 
    component: () => import('./components/page_payment/p_1.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/account/add/Slots', 
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
  { 
    path: '/account/view/Slots', 
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
  { 
    path: '/account/view/stats', 
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
    { 
    path: '/account/view/payments', 
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
    { 
    path: '/account/view/notifications', 
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
    {
    path: '/account/view/notification-settings',
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/account/view/reviews',
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/account/assessments', 
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/account/activity',
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
  { 
    path: '/account/notes', 
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
  { 
    path: '/account/reports', 
    component: accountDashboard,
    meta: { requiresAuth: true }
  },
  { 
    path: '/account/admin', 
    component: () => import('./components/page_admin/p_1.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/tutor/profile/:id', 
    component: () => import('./components/page_account_tutor_profile/tutor_profile.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/terms',
    component: () => import('./components/page_terms/p_1.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/privacy',
    component: () => import('./components/page_privacy/p_1.vue'),
    meta: { requiresAuth: false }
  },

  // Wildcard route to redirect to '/' if path does not exist
  { path: '/:pathMatch(.*)*', redirect: '/' }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  // Check if route requires authentication
  if (to.meta.requiresAuth) {
    // Check if user data exists in the store
    if (!store.getters.userData) {
      // If user data does not exist, fetch it from the server
      store.dispatch('fetchUserData').then(() => {
        // Proceed to the next route after fetching user data
        next();
      });
    } else {
      // User data exists, proceed to the next route
      next();
    }
  } else {
    // Route does not require authentication, proceed to the next route
    next();
  }
});

// After a deploy, a tab still running the previous build can fail to load a
// page's code because the old files were replaced on the server. Load the
// target page fresh in that one case (once per page, so it can never loop).
router.onError((error, to) => {
  const isChunkError = /Loading (CSS )?chunk [\w-]+ failed|Failed to fetch dynamically imported module/i.test(
    error?.message || ''
  );
  if (!isChunkError) return;
  const key = `chunk-reload:${to?.fullPath || ''}`;
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  } catch (e) {
    return;
  }
  window.location.assign(to?.fullPath || window.location.href);
});

export default router;
